import apiService from 'util/apiService';
import {
  OPEN_VIEW_DRAWER,
  CLOSE_VIEW_DRAWER,
  SET_CURRENT_VIEW,
  SET_DEFAULT_VIEW,
  SET_DEFAULT_VIEW_START,
  SET_DEFAULT_VIEW_FAILURE,
  OPEN_VIEW_DIALOG,
  CLOSE_VIEW_DIALOG,
  SET_DIALOG_TYPE,
  SET_DIALOG_SUBTYPE,
  SAVE_VIEW_START,
  SAVE_VIEW_SUCCESS,
  SAVE_VIEW_FAILURE,
  DELETE_VIEW_START,
  DELETE_VIEW_SUCCESS,
  DELETE_VIEW_FAILURE,
  RENAME_VIEW_START,
  RENAME_VIEW_SUCCESS,
  RENAME_VIEW_FAILURE,
  FETCH_VIEWS_START,
  FETCH_VIEWS_SUCCESS,
  FETCH_VIEWS_FAILURE,
  EDIT_VIEW_START,
  EDIT_VIEW_SUCCESS,
  EDIT_VIEW_FAILURE,
  CLEAR_VIEW_MANAGEMENT_ALERTS,
  SET_SELECTED_VIEW_FOR_EDIT,
  SET_SELECTED_VIEWS,
  CLEAR_SELECTED_VIEWS,
  SET_SITE_LIST,
  SET_NO_ACCESS_SITE_LIST,
  SET_COST_CENTER_LIST,
  SET_QUICK_LINK_CONTACTS_LIST,
  CLEAR_ALL_LISTS,
  FETCH_PRIMARY_LIST_DATA_START,
  FETCH_PRIMARY_LIST_DATA_SUCCESS,
  FETCH_PRIMARY_LIST_DATA_FAILURE,
  SET_FILTERED_SITE_LIST,
  SET_FILTERED_COST_CENTER_LIST,
  CLEAR_ALL_FILTERED_LISTS,
  SET_DEFAULT_FILTERED_SITE_LIST,
  SET_DEFAULT_FILTERED_COST_CENTER_LIST,
  CLEAR_ALL_DEFAULT_FILTERED_LISTS,
  SET_VIEW_AND_USER_CONFIG_READY,
  SYSTEM_DEFAULT_VIEW_TYPE
} from './constants';
import { setCommonAlerts } from 'modules/cbre-flow-Common/actions';

// Drawer Actions
export const openViewDrawer = () => ({
  type: OPEN_VIEW_DRAWER
});

export const closeViewDrawer = () => ({
  type: CLOSE_VIEW_DRAWER
});

export const setCurrentView = (payload) => ({
  type: SET_CURRENT_VIEW,
  payload
});

// Shared thunk to set a given view as default using portfolio view metadata.
export const setDefaultViewByViewData = (viewData) => {
  return (dispatch, getState) => {
    const state = getState();
    const baseUrl = state?.config?.client?.flowApiUrl || '';
    const portfolioViewId = viewData?.portfolioViewId;
    const clientCode = viewData?.clientCode;

    if (!baseUrl || !portfolioViewId || !clientCode) {
      return;
    }

    const apiUrl = `${baseUrl}api/portfolio-views/${portfolioViewId}/set-default?clientCode=${clientCode}`;
    return dispatch(setDefaultView({ apiUrl, viewData }));
  };
};

// Thunk action to switch portfolio to system default view based on clientCode
export const switchPortfolioToSystemDefaultView = (clientCode) => {
  return (dispatch, getState) => {
    const state = getState();
    const views = state?.viewManagement?.views || [];
    
    // Find the system default view for the given clientCode
    const systemDefaultView = views.find(
      (view) => view?.viewType === SYSTEM_DEFAULT_VIEW_TYPE && view?.clientCode === clientCode
    );
    
    if (systemDefaultView) {
      return dispatch(setDefaultViewByViewData(systemDefaultView));
    }
  };
};

export const setDefaultViewSuccess = (payload) => ({
  type: SET_DEFAULT_VIEW,
  payload
});

export const setDefaultViewStart = () => ({
  type: SET_DEFAULT_VIEW_START,
});

export const setDefaultViewFailure = (payload) => ({
  type: SET_DEFAULT_VIEW_FAILURE,
  payload,
});

// Async action to set default view
export const setDefaultView = (payload) => {
  const { apiUrl, viewData, fetchViewUrl } = payload;

  return (dispatch) => {
    dispatch(setDefaultViewStart());
    return apiService
      .patch(apiUrl, viewData)
      .then((res) => {
        const { statusCode, data } = res;
        if (statusCode === 200 || statusCode === 201) {
          dispatch(setDefaultViewSuccess(data));
          // dispatch(setCommonAlerts({ 
          //   message: 'Default view set successfully', 
          //   type: 'success' 
          // }));
          // Fetch the updated view data
          // if (fetchViewUrl) {
          //   dispatch(fetchViews({ apiUrl: fetchViewUrl }));
          // }
        } else {
          dispatch(setDefaultViewFailure({ messageCode: 'Failed to set default view' }));
          dispatch(setCommonAlerts({ 
            message: 'Failed to set default view', 
            type: 'failure' 
          }));
        }
        return res;
      })
      .catch((err) => {
        dispatch(setDefaultViewFailure({ messageCode: err?.message || 'Failed to set default view' }));
        dispatch(setCommonAlerts({ 
          message: 'Failed to set default view', 
          type: 'failure' 
        }));
      });
  };
};

// Dialog Actions
export const openViewDialog = (dialogType, dialogSubtype = null, data = null) => ({
  type: OPEN_VIEW_DIALOG,
  payload: { dialogType, dialogSubtype, data }
});

export const closeViewDialog = () => ({
  type: CLOSE_VIEW_DIALOG
});

export const setDialogType = (payload) => ({
  type: SET_DIALOG_TYPE,
  payload
});

export const setDialogSubtype = (payload) => ({
  type: SET_DIALOG_SUBTYPE,
  payload
});

// Clear alerts
export const clearViewManagementAlerts = () => ({
  type: CLEAR_VIEW_MANAGEMENT_ALERTS
});

// Selection Actions
export const setSelectedViewForEdit = (view) => ({
  type: SET_SELECTED_VIEW_FOR_EDIT,
  payload: view
});

export const setSelectedViews = (views) => ({
  type: SET_SELECTED_VIEWS,
  payload: views
});

export const clearSelectedViews = () => ({
  type: CLEAR_SELECTED_VIEWS
});

// Save View Actions
export const saveViewStart = () => ({
  type: SAVE_VIEW_START
});

export const saveViewSuccess = (payload) => ({
  type: SAVE_VIEW_SUCCESS,
  payload
});

export const saveViewFailure = (payload) => ({
  type: SAVE_VIEW_FAILURE,
  payload
});

// Delete View Actions
export const deleteViewStart = () => ({
  type: DELETE_VIEW_START
});

export const deleteViewSuccess = (payload) => ({
  type: DELETE_VIEW_SUCCESS,
  payload
});

export const deleteViewFailure = (payload) => ({
  type: DELETE_VIEW_FAILURE,
  payload
});

// Rename View Actions
export const renameViewStart = () => ({
  type: RENAME_VIEW_START
});

export const renameViewSuccess = (payload) => ({
  type: RENAME_VIEW_SUCCESS,
  payload
});

export const renameViewFailure = (payload) => ({
  type: RENAME_VIEW_FAILURE,
  payload
});

// Get Views Actions
export const fetchViewsStart = () => ({
  type: FETCH_VIEWS_START
});

export const fetchViewsSuccess = (payload) => ({
  type: FETCH_VIEWS_SUCCESS,
  payload
});

export const fetchViewsFailure = (payload) => ({
  type: FETCH_VIEWS_FAILURE,
  payload
});

// Edit View Actions
export const editViewStart = () => ({
  type: EDIT_VIEW_START
});

export const editViewSuccess = (payload) => ({
  type: EDIT_VIEW_SUCCESS,
  payload
});

export const editViewFailure = (payload) => ({
  type: EDIT_VIEW_FAILURE,
  payload
});

// Async Actions
export const saveView = (payload) => {
  const { apiUrl, viewData, mode } = payload;

  return (dispatch) => {
    dispatch(saveViewStart());
    const method = mode === 'update' ? 'put' : 'post';
    return apiService
      [method](apiUrl, viewData)
      .then((res) => {
        const { statusCode, messageCode, data } = res;
        if (statusCode === 200 || statusCode === 201) {
          dispatch(saveViewSuccess(data));
          dispatch(setCommonAlerts({ 
            message: 'View saved successfully', 
            type: 'success' 
          }));
          dispatch(closeViewDialog());
          dispatch(closeViewDrawer());
        } else {
          dispatch(saveViewFailure(messageCode));
          dispatch(setCommonAlerts({ 
            message: 'Failed to save view', 
            type: 'failure' 
          }));
        }
        return res;
      })
      .catch((err) => {
        dispatch(saveViewFailure({ messageCode: err.message }));
        dispatch(setCommonAlerts({ 
          message: 'Failed to save view', 
          type: 'failure' 
        }));
      });
  };
};
// Async Actions
export const renameViewAction = (payload) => {
  const { apiUrl, viewData, mode } = payload;

  return (dispatch) => {
    dispatch(renameViewStart());
    return apiService.patch(apiUrl, viewData)
      .then((res) => {
        const { statusCode, messageCode, data } = res;
        if (statusCode === 200 || statusCode === 201) {
          dispatch(renameViewSuccess(data));
          dispatch(setCommonAlerts({ 
            message: 'View renamed successfully', 
            type: 'success' 
          }));
          dispatch(closeViewDialog());
          dispatch(closeViewDrawer());
        } else {
          dispatch(renameViewFailure(messageCode));
          dispatch(setCommonAlerts({ 
            message: 'Failed to rename view', 
            type: 'failure' 
          }));
        }
        return res;
      })
      .catch((err) => {
        dispatch(renameViewFailure({ messageCode: err.message }));
        dispatch(setCommonAlerts({ 
          message: 'Failed to rename view', 
          type: 'failure' 
        }));
      });
  };
};


export const deleteView = (payload) => {
  const { apiUrl, viewData } = payload;

  
  return (dispatch) => {
    dispatch(deleteViewStart());
    
    
    return apiService.delete(`${apiUrl}`)
      .then((response) => {
        const { statusCode } = response;
        
        if (statusCode === 200) {
          dispatch(deleteViewSuccess(viewData));
          dispatch(setCommonAlerts({ 
            message: `${viewData.viewName} view deleted successfully`, 
            type: 'success' 
          }));
          dispatch(closeViewDialog());
          dispatch(closeViewDrawer());
          // Refresh the views list
          // dispatch(fetchViews({ apiUrl }));
        } else {
          dispatch(deleteViewFailure({ messageCode: 'Failed to delete view' }));
          dispatch(setCommonAlerts({ 
            message: 'Failed to delete view', 
            type: 'failure' 
          }));
        }
        return response;
      })
      .catch((err) => {
        dispatch(deleteViewFailure({ messageCode: err.message }));
        dispatch(setCommonAlerts({ 
          message: 'Failed to delete view(s)', 
          type: 'failure' 
        }));
      });
  };
};


export const editView = (payload) => {
  const { apiUrl, viewId, viewData } = payload;

  return (dispatch) => {
    dispatch(editViewStart());
    return apiService
      .put(`${apiUrl}/${viewId}`, viewData)
      .then((res) => {
        const { statusCode, messageCode, data } = res;
        if (statusCode === 200) {
          dispatch(editViewSuccess(data));
          dispatch(setCommonAlerts({ 
            message: 'View updated successfully', 
            type: 'success' 
          }));
          dispatch(closeViewDialog());
          dispatch(closeViewDrawer());
        } else {
          dispatch(editViewFailure(messageCode));
          dispatch(setCommonAlerts({ 
            message: 'Failed to update view', 
            type: 'failure' 
          }));
        }
        return res;
      })
      .catch((err) => {
        dispatch(editViewFailure({ messageCode: err.message }));
        dispatch(setCommonAlerts({ 
          message: 'Failed to update view', 
          type: 'failure' 
        }));
      });
  };
};

export const fetchViews = (payload) => {
  const { apiUrl } = payload;

  return (dispatch) => {
    dispatch(fetchViewsStart());
    return apiService
      .get(apiUrl)
      .then((res) => {
        const { statusCode } = res;
        if (statusCode === 200) {
          const data = res.data?.data || {};
          dispatch(fetchViewsSuccess(data));
          dispatch(setCurrentView(data.viewName || null));

          dispatch(setAllFilteredLists(
            data.viewName || null,
            data.filterSelections?.sites || [],
            data.filterSelections?.costCenters || []
          ));
          dispatch(setAllDefaultFilteredLists(
            data.viewName || null,
            data.filterSelections?.sites || [],
            data.filterSelections?.costCenters || []
          ));
        } else {
          dispatch(fetchViewsFailure({ messageCode: 'Failed to fetch views' }));
        }
        return res;
      })
      .catch((err) => {
        dispatch(fetchViewsFailure({ messageCode: err.message }));
      });
  };
};

// List Management Actions
export const setSiteList = (siteList) => ({
  type: SET_SITE_LIST,
  payload: siteList
});

export const setNoAccessSiteList = (noAccessSiteList) => ({
  type: SET_NO_ACCESS_SITE_LIST,
  payload: noAccessSiteList
});

export const setCostCenterList = (costCenterList) => ({
  type: SET_COST_CENTER_LIST,
  payload: costCenterList
});

export const setQuickLinkContactsList = (quickLinkContactsList) => ({
  type: SET_QUICK_LINK_CONTACTS_LIST,
  payload: quickLinkContactsList
});

export const clearAllLists = () => ({
  type: CLEAR_ALL_LISTS
});

export const fetchPrimaryListDataStart = () => ({
  type: FETCH_PRIMARY_LIST_DATA_START,
});

export const fetchPrimaryListDataSuccess = () => ({
  type: FETCH_PRIMARY_LIST_DATA_SUCCESS,
});

export const fetchPrimaryListDataFailure = (payload) => ({
  type: FETCH_PRIMARY_LIST_DATA_FAILURE,
  payload,
});

// Combined action to set all lists at once
export const setAllLists = (siteList, costCenterList, noAccessSiteList) => {
  return (dispatch) => {
    dispatch(setSiteList(siteList));
    dispatch(setNoAccessSiteList(noAccessSiteList));
    dispatch(setCostCenterList(costCenterList));
  };
};

// Filtered List Management Actions
export const setFilteredSiteList = (viewName, filteredSiteList) => ({
  type: SET_FILTERED_SITE_LIST,
  payload: { viewName, data: filteredSiteList }
});

export const setFilteredCostCenterList = (viewName, filteredCostCenterList) => ({
  type: SET_FILTERED_COST_CENTER_LIST,
  payload: { viewName, data: filteredCostCenterList }
});

export const clearAllFilteredLists = () => ({
  type: CLEAR_ALL_FILTERED_LISTS
});

// Default Filtered List Management Actions (for API provided data)
export const setDefaultFilteredSiteList = (viewName, defaultFilteredSiteList) => ({
  type: SET_DEFAULT_FILTERED_SITE_LIST,
  payload: { viewName, data: defaultFilteredSiteList }
});

export const setDefaultFilteredCostCenterList = (viewName, defaultFilteredCostCenterList) => ({
  type: SET_DEFAULT_FILTERED_COST_CENTER_LIST,
  payload: { viewName, data: defaultFilteredCostCenterList }
});

export const clearAllDefaultFilteredLists = () => ({
  type: CLEAR_ALL_DEFAULT_FILTERED_LISTS
});

export const setViewAndUserConfigReady = (payload) => ({
  type: SET_VIEW_AND_USER_CONFIG_READY,
  payload,
});


// Combined action to set all filtered lists at once
export const setAllFilteredLists = (viewName, filteredSiteList, filteredCostCenterList) => {
  return (dispatch) => {
    dispatch(setFilteredSiteList(viewName, filteredSiteList));
    dispatch(setFilteredCostCenterList(viewName, filteredCostCenterList));
  };
};

// Combined action to set all filtered lists at once
export const setAllDefaultFilteredLists = (viewName, filteredSiteList, filteredCostCenterList) => {
  return (dispatch) => {
    dispatch(setDefaultFilteredSiteList(viewName, filteredSiteList));
    dispatch(setDefaultFilteredCostCenterList(viewName, filteredCostCenterList));
  };
};


// Action to filter lists based on search criteria
export const filterLists = (viewName, searchTerm = '', filterCriteria = {}) => {
  return (dispatch, getState) => {
    const { siteList, costCenterList } = getState()['cbre-flow-view-management'];
    
    // Filter sites
    const filteredSites = siteList.filter(site => 
      site.siteName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      site.client?.toLowerCase().includes(searchTerm.toLowerCase())
    );
    
    // Filter cost centers
    const filteredCostCenters = costCenterList.filter(costCenter => 
      costCenter.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      costCenter.description?.toLowerCase().includes(searchTerm.toLowerCase())
    );
    
    dispatch(setFilteredSiteList(viewName, filteredSites));
    dispatch(setFilteredCostCenterList(viewName, filteredCostCenters));
  };
};

export const fetchPrimaryListData = (url, payloadKey) => {
  return (dispatch) => {
    dispatch(fetchPrimaryListDataStart());

    return apiService
      .get(url)
      .then((res) => {
        const { statusCode, data } = res;
        if (statusCode === 200) {
          switch (payloadKey) {
            case 'siteList':
              dispatch(setSiteList(data.accessSites?.data || []));
              break;
            case 'noAccessSiteList':
              dispatch(setNoAccessSiteList(data.noAccessSites?.data || []));
              break;
            case 'costCenterList':
              dispatch(setCostCenterList(data.allCostCenters?.data || []));
              break;
            case 'allLists':
              dispatch(setAllLists(
                data.accessSites?.data || [],
                data.allCostCenters?.data || [],
                data.noAccessSites?.data || []
              ));
              break;
            default:
              break;
          }
          dispatch(fetchPrimaryListDataSuccess());
        }else{
          throw new Error(`Failed to fetch ${payloadKey}`);
        }
        return res;
        
      })
      .catch((err) => {
        dispatch(fetchPrimaryListDataFailure({ messageCode: err.message }));
        console.error(`Error fetching ${payloadKey}:`, err);
        throw err;
      });
  };
}

export const fetchQuickLinkContacts = (url) => {
  return (dispatch) => {
    return apiService
      .get(url)
      .then((res) => {
        const { statusCode, data } = res;
        if (statusCode === 200) {
          dispatch(setQuickLinkContactsList(data || []));
        } else {
          throw new Error('Failed to fetch quick link contacts');
        }
        return res;
      })
      .catch((err) => {
        console.error('Error fetching quick link contacts:', err);
        throw err;
      });
  };
};

const fetchFilteredData = (url, payloadKey) => {
  return (dispatch) => {
    return apiService
      .get(url)
      .then((res) => {
        const { statusCode, data } = res;
        if (statusCode === 200) {
          switch (payloadKey) {
            case 'filteredSiteList':
              dispatch(setFilteredSiteList(data.filteredSiteList || []));
              break;
            case 'filteredCostCenterList':
              dispatch(setFilteredCostCenterList(data.filteredCostCenterList || []));
              break;
            default:
              break;
          } 
        }
        return res;
      })
      .catch((err) => {
        console.error(`Error fetching ${payloadKey}:`, err);
      } );
  };
}
